import unavailableAvatarImageUrl from '../../../assets/images/avatar-unavailable.png';
import { getAvatar } from '../../../api/api';
import { useApi } from '../../../hooks/use-api';

/**
 * Accepts/fetches avatar data and computes necessary fields for the user menu components
 */
export const useUserMenuAvatar = ({ avatarData, getData = false } = {}) => {
  const { data: fetchedAvatarData } = useApi({
    requestFn: getAvatar,
    onError: (error) => {
      console.error('Your avatar data has failed to load.', error);
    },
    skipInitialCall: !getData,
  });

  const avatar = getData ? fetchedAvatarData : avatarData;

  // Avatar
  const portalAvatar = avatar?.portalAvatar;
  const mixAvatar = avatar?.mixAvatar;
  const mixAvatarInUse = portalAvatar === null && mixAvatar;

  // Avatar - img src
  const avatarSrc = mixAvatarInUse
    ? `data:image/jpeg;base64,${mixAvatar?.image}`
    : portalAvatar?.url;

  // Avatar - alt text
  const avatarAlt = mixAvatarInUse
    ? 'headshot on student id card'
    : portalAvatar?.description;

  return {
    avatarSrc: avatarSrc || unavailableAvatarImageUrl,
    avatarAlt: avatarAlt || 'Avatar unavailable',
  };
};
